module.exports = __webpack_public_path__ + "img/1572332953.37f2a9e9.jpg";